<template>
  <div class="details-page-container">
    <nav-bar @indexChange="checkMenuIndexChange"></nav-bar>
    <div class="details-content">
        <case-page v-if="menuIndex == 1"></case-page>
        <solution-page v-if="menuIndex == 2"></solution-page>
        <service-page v-if="menuIndex == 3"></service-page>
        <contact-page v-if="menuIndex == 4"></contact-page>
        <about-us-page v-if="menuIndex == 5"></about-us-page>
    </div>
    <page-footer></page-footer>
    <card-btn @click.native="openCard"></card-btn>
    <business-card ref="businessCard"></business-card>
  </div>
</template>

<script>
import navBar from "@/components/navBar";
import casePage from "@/views/details/components/casePage";
import solutionPage from "@/views/details/components/solutionPage";
import contactPage from "@/views/details/components/contactPage";
import aboutUsPage from "@/views/details/components/aboutUsPage";
import servicePage from "@/views/details/components/servicePage";
import pageFooter from "@/components/pageFooter";
import cardBtn from "@/components/cardBtn";
import businessCard from "@/components/businessCard";
export default {
  components: {
    navBar,
    casePage,
    solutionPage,
    contactPage,
    aboutUsPage,
    servicePage,
    pageFooter,
    cardBtn,
    businessCard,
  },
  mounted() {
    this.menuIndex = this.$route.query.menuIndex;
    // this.backtop();
  },
  data() {
    return {
      menuIndex: null,
    };
  },
  watch: {
    menuIndex(newValue) {
      this.backtop();
    },
  },
  methods: {
    checkMenuIndexChange(index) {
      this.menuIndex = index;
    },
    // 回到顶部
    backtop() {
      var timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 4);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
        this.isTop = true;
      }, 20);
      // document.body.scrollTop = 0;
    },
    openCard() {
      this.$refs.businessCard.open();
    },
  },
};
</script>

<style lang="scss" scoped>
.details-page-container {
  width: 100%;
  min-width: 1240px;
  position: relative;
  .details-content {
    margin-top: 74px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/details/detailsPage.vue